import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "fx-bold" }, "Cookie settings", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "small mb-0" }, "We use cookies and similar technologies to help personalize content and offer a better experience. You can customize them by clicking the preferences button.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_vue_cookie_comply = _resolveComponent("vue-cookie-comply")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_vue_cookie_comply, { preferences: _ctx.preferences }, {
      header: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }, 8, ["preferences"])
  ], 64))
}